import {DataTableColumn} from "mantine-datatable";
import {Price} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {PriceStatusBadge} from "../profile/PriceStatusBadge.tsx";
import {PriceDisplayBadge} from "../profile/PriceDisplayBadge.tsx";
import {PriceRecurringOptionBadge} from "../profile/PriceRecurringOptionBadge.tsx";


export const useTableColumns = () => {

    const columns: DataTableColumn<Price>[] = [
        {
            accessor: 'id',
            title: I18n.get('Price'),
            width: '1fr',
            render: (item: Price) => <NavLink to={`/products/${item.productId}/prices/${item.id}`}><PriceDisplayBadge
                record={item}/></NavLink>,
        },
        {
            accessor: 'pricingModel',
            title: I18n.get('Pricing Model'),
            width: '1fr',
            render: (item: Price) => item.pricingModel,
        },
        {
            accessor: 'recurringOption',
            title: I18n.get('Recurring'),
            width: '1fr',
            render: (item: Price) => <PriceRecurringOptionBadge record={item}/>,
        },
        {
            accessor: 'billingPeriod',
            title: I18n.get('Billing Period'),
            width: '1fr',
            render: (item: Price) => item.billingPeriod ? item.billingPeriod : 'n/a',
        },
        {
            accessor: 'priceStatus',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Price) => <PriceStatusBadge record={item}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Price) => formatTimestamp(item.created as string),
        },

    ];

    return {
        columns,
    }
}